// finish
import React from "react";
import Button from "@mui/material/Button";
import "../../css/style.css";
import theme from "../../css/theme";
import { useNavigate } from "react-router-dom";

const Finish = () => {
  const navigate = useNavigate();

  return (
    <main className="finish">
      <h2 className="finish">Inscrierile pentru Cursa Sponsorilor vor incepe in 6 iunie 2023.</h2>
      <h2 className="finish">Va dorim mult succes in competitie!</h2>
      <div className="finish">
        <Button
          className="kids-button"
          variant="contained"
          theme={theme}
          type="submit"
          onClick={() => {
            navigate("/");
          }}
        >
          {" "}
          Acasa{" "}
        </Button>
      </div>
    </main>
  );
};

export default Finish;
